module.exports = __webpack_public_path__ + "img/youtube_white.567febc6.png";